"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_fbf = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_fbf = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAZCAIAAACpVwlNAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAR9JREFUSEvtkjGrRlAYx21mymdQJqt8A9OVUSkjSrY7MihllJV8D7FbLWZWyo5yn9c56r3uWzfF5teJ8/zPv99wIFbirrW97uBRH3jUBw7qaZq+fiPLMuTw1HXdNE3btqMoGscR9VVVxb2dYRjQ0Qc1JIZhfL8BOUVRkiR5nheGoaZpLMuiPs/zoiji3sY8z+jos7ptWzzvgDpNUzysK8MweZ7DBtSu66LwyFn1sixFUdA0DU0YT6vfqaoKclDjecP3fdQHNY424CZR/gLmv+qyLJsdlIM6jmP4en3fZ1lGkmSSJJCD2rIsXG2arutQ/8VH9b93LQiCoiiwufKugbquOY4LggD216ghR8Dv4TgOyk+or+RRH3jUB7D6jkUQP5EtET1/qwRZAAAAAElFTkSuQmCC",
    iconSize: [30, 25],
});
